export class Company {
    RowId: number;
    Id: number;
    Name: string;
    Piva: string;
    Website: string;
    StreetAddress: string;
    PostalCode: string;
    City: string;
    Province: string;
    Phone: string;
    Email: string;
    Facebook: string;
    Twitter: string;
    Youtube: string;
    Instagram: string;
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/core/company.ts